"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownCC = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const UnknownCC = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 19"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  width: 24.5,
  height: 17.5,
  x: -0.25,
  y: -0.25,
  fill: "#FFF",
  stroke: "#E7E9EF",
  strokeWidth: 0.5,
  rx: 2
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#004E8C",
  d: "M0 3h24v3H0z"
}), /*#__PURE__*/_react.default.createElement("rect", {
  width: 4,
  height: 4,
  x: 18,
  y: 10,
  fill: "#004E8C",
  rx: 1
})));
exports.UnknownCC = UnknownCC;
UnknownCC.displayName = "UnknownCC";